import { styledTag } from 'src/utils/styled';

const RenderLineBreaks = styledTag('p')`
    white-space: pre-line;
    overflow-wrap: anywhere;
`;

export default RenderLineBreaks;
